<script lang="ts">
  import { splitProductAndTextLogs } from "../../../lib/conversation";
  import ProductResponse from "./ProductResponse.svelte";
  import TextResponse from "./TextResponse.svelte";

  export let s;
  export let text;
  export let overrideStyle = "";

  let splitLogs: Array<{ text?: string; productUrl?: string }> = [];

  $: splitLogs = splitProductAndTextLogs(text);
</script>

<div class={s.messageInnerWrapper}>
  {#each splitLogs as log}
    {#if log.productUrl}
      <ProductResponse {s} {log} />
    {:else}
      <TextResponse {s} {log} {overrideStyle} />
    {/if}
  {/each}
</div>
